const detail = require('../product/detail');

/**
 * replaces the content in the modal window for product variation to be edited.
 * @param {string} editProductUrl - url to be used to retrieve a new product model
 */
function insertProductToModal(editProductUrl) {
    const $quickViewModal = $('#editProductModal');
    const $quickViewModalContent = $quickViewModal.find('.js-quick-view-yield');
    const modalPaddings = parseFloat($quickViewModalContent.css('padding-top')) + parseFloat($quickViewModalContent.css('padding-bottom'));
    $quickViewModalContent
        .empty()
        .attr('aria-busy', 'true')
        .css('height', 300);

    $.ajax({
        url: editProductUrl,
        method: 'GET',
        dataType: 'json',
        success(data) {
            $quickViewModalContent
                .removeAttr('aria-busy')
                .html(data.renderedTemplate);

            const contentHeight = $quickViewModalContent[0].firstElementChild.clientHeight + modalPaddings;
            $quickViewModalContent.css('height', contentHeight);
            const colorName = $('.js-color-button.m-selected').data('attr-value');
            if (colorName) {
                $('.js-selected-color').text(colorName);
            }
        },
        error() {
            $quickViewModalContent.removeAttr('aria-busy');
            window.dialogManager.closeDialog();
            $quickViewModal.modal('hide');
        }
    });
}

function updateCart(e) {
    e.preventDefault();

    const $updateProductData = $('#update-product-data');
    const updateProductUrl = $updateProductData.val();
    if (!updateProductUrl) {
        return;
    }

    const $body = $('body');
    const $cart = $('.js-cart');
    const quantity = $updateProductData.data('selected-quantity');
    const uuid = $updateProductData.data('uuid');
    const pid = $updateProductData.data('pid');

    const form = {
        uuid,
        pid,
        quantity
    };

    $cart.spinner().start();

    $.ajax({
        url: updateProductUrl,
        type: 'post',
        context: this,
        data: form,
        dataType: 'json',
        success(data) {
            $('.js-quick-view-yield').empty();
            window.dialogManager.closeDialog();
            $('.js-wai-messages').show().text($('#edit-success-message').html());

            $body
                .trigger('basket:update:totals', data.cartModel)
                .trigger('basket:update:discounts', { discounts: data.cartModel.approachingDiscounts })
                .trigger('basket:update:promos', data.cartModel.totals.discountsHtml)
                .trigger('basket:update:availability', { data: data.cartModel, uuid })
                .trigger('basket:update:details', { data, uuid })
                .trigger('basket:validate', data.cartModel);

            if (data.uuidToBeDeleted) {
                $(`.uuid-${data.uuidToBeDeleted}`).remove();
            }

            $cart.spinner().stop();
        },
        error(err) {
            if (err.responseJSON.redirectUrl) {
                window.window.location.href = err.responseJSON.redirectUrl;
            } else {
                window.dialogManager.closeDialog();
                $body.trigger('basket:notify', err.responseJSON.errorMessage);
                $cart.spinner().stop();
            }
        }
    });
}

function updateAttrs(product) {
    const $productAttributeElements = $('.js-product-detail').find('[data-attribute]');

    //Update product attributes data elements and togle its visibility
    $productAttributeElements.each((index, element) => {
        const attributeBinding = $(element).data('attribute');
        const attributeValue = product[attributeBinding];

        $(element).text(attributeValue);
        $(element).closest('.js-attribute_container').toggleClass('h-hidden', !attributeValue);
    });
}

function updateImage(images) {
    $('.js-quick-view-image')
        .attr('src', images.medium[0].url)
        .attr('alt', images.medium[0].alt);
}

module.exports = function () {
    const $body = $('body');

    $body.append($('#quickview-modal-template').html());

    $body.on('click', '.js-edit-line-item', function (e) {
        e.preventDefault();

        const editProductUrl = $(this).attr('data-href');
        insertProductToModal(editProductUrl);
    });

    $body.on('click', '.js-update-cart-product-global', updateCart);

    $body.on('product:afterAttributeSelect', (e, data) => {
        const product = data.data && data.data.product;

        if (product) {
            updateAttrs(product);
            updateImage(product.images);
            $('#update-product-data').attr('data-pid', product.id);

            $('.js-update-cart-product-global').prop('disabled',
                !(product.readyToOrder && (product.available || product.availableForInStorePickup))
            );
        }
    });

    $body.on('product:afterAttributeSelect', (e, data) => {
        const $quickViewModal = $('#editProductModal');
        const $quickViewModalContent = $quickViewModal.find('.js-quick-view-yield');
        const modalPaddings = parseFloat($quickViewModalContent.css('padding-top')) + parseFloat($quickViewModalContent.css('padding-bottom'));

        const contentHeight = data.container.height() + modalPaddings;
        $quickViewModalContent.css('height', contentHeight);
    });

    detail.updateAvailability();
};
